import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Waypoint's own scales (the preset's names), so tailwind-merge knows that `text-body-sm` is a
 * size and `text-ink-subtle` a colour, and that `h-[34px]` replaces `h-control-md`. Without this,
 * two classes of one kind resolve by their order in the stylesheet, not by the order they were
 * written — a caller's override would silently lose.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['mega', 'hero', 'display', 'h1', 'h2', 'h3', 'title', 'body-lg', 'body', 'body-sm', 'caption', 'sign', 'button', 'mono', 'mono-sm', 'metric', 'plate'] }],
      shadow: [{ shadow: ['1', '2', '3', '4'] }],
      h: [{ h: ['control-sm', 'control-md', 'control-lg'] }],
      'min-h': [{ 'min-h': ['target', 'control-md'] }],
      'min-w': [{ 'min-w': ['target'] }],
      z: [{ z: ['map', 'map-overlay', 'panel', 'header', 'dropdown', 'sheet', 'modal', 'toast', 'tooltip'] }],
      animate: [{ animate: ['lane-flow', 'route-draw', 'pin-drop', 'ping', 'arrive'] }],
      duration: [{ duration: ['tap', 'quick', 'base', 'move', 'sheet', 'odometer', 'flow', 'route', 'ping'] }],
      ease: [{ ease: ['drive', 'arrive', 'depart', 'pin'] }],
    },
  },
});

/** Joins class names; of two that set the same thing, the later one wins. */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
